<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Account Dashboard
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="current_academic_year" :items="academic_year_list"
                        item-text="ay" return-object label="Academic Year" outlined persistent-hint
                        hint="Please Select Academic Year"></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="std" :items="standard_list" item-text="standard"
                        return-object label="Standard" outlined persistent-hint
                        hint="Please Select Standard"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list"
                        item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
                </v-col>
                <v-col cols="12" md="3" sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="type" :items="type_list"
                        item-text="name" item-value="id" label="Fee Type" outlined persistent-hint
                        hint="Select Fee Type" />
                </v-col>
                <!-- <v-col sm="2" v-if="std!=''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="div" :items="dision_list" item-text="div_name" item-value="div_off_id" label="Division" outlined ></v-autocomplete>
                </v-col> -->
                <v-col sm="2">
                    <v-btn rounded class="button mt-6" @click="getAllReport();" :loading="loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-row dense v-if="learner_info!=''">
                <v-btn class="ma-2 no-display " rounded color="success" outlined
                    @click="fnExcelReport('my-table-id', 'AccountDashBoardReport')" :loading="loader"><v-icon
                        color="success">mdi-export</v-icon>Export</v-btn>
            </v-row>
            <span v-if="learner_info!=''">
                <account-dashboard-common :learner_info="learner_info" :type="type"
                    :component_headers="component_headers"></account-dashboard-common>
            </span>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import AccountDashaboardCommon from "./AccountDashaboardCommon";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        components:{
            "account-dashboard-common": AccountDashaboardCommon,
            Breadcrumbs
        },
        data() {
            return {
                loader: false,
                color: "",
                snackbar: false,
                search: null,
                snackbar_msg: null,
                fees_structure_data: null,
                current_academic_year: null,
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                stream: null,
                div: null,
                std: "",
                header: null,
                academic_year_list: null,
                standard_list: null,
                dision_list: null,
                stream_list: null,
                header_list: null,
                show: false,
                learner_info: [],
                data_list: [],
                component_headers: [],
                all_total_amount:null,
                all_total_paid:null,
                all_total_remaining:null,
                org:null,
                status_list: [
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
                ],
                status: null,
                type_list: [
                    { name: "All", id: "0" },
                    { name: "Installment", id: "1" },
                    { name: "Misc Fee", id: "2" },
                    { name: "Canteen Fee", id: "3" },
                ],
                type: null,
            };
        },
        methods: {
    fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>Sr. No.</th>
      <th>Registration No.</th>
      <th>Name</th>
      <th>Mobile No.</th>
      <th>Personal Email</th>
      <th>Quota</th>
      <th>Academic Year</th>
      <th>Admission Year</th>
      <th>Standard</th>
      <th>Division</th>
      <th>Fees Concession</th>
      <th>Excess Amount</th>
      <th>No. Of Receipts</th>
      <th>Installment Details</th>
      <th>Misc Fee Details</th>
      <th>Canteen Fee Details</th>
      <th>Total Amount</th>
      <th>Paid Amount</th>
      <th>Remaining Amount</th>
    </tr>`;

  this.learner_info.forEach((item, index) => {
    tab_text += `
    <tr>
      <td>${index + 1}</td>
      <td>${item.reg_no || ''}</td>
      <td>${item.name || ''}</td>
      <td>${item.primary_contact_number || ''}</td>
      <td>${item.personal_email || ''}</td>
      <td>${item.quota || ''}</td>
      <td>${item.academicyear || ''}</td>
      <td>${item.learner_addmission_year || ''}</td>
      <td>${item.standard || ''}</td>
      <td>${item.div || ''}</td>
      <td>${item.concession || ''}</td>
      <td>${item.excess_amount}</td>
      <td>${item.receipts_count || ''}</td>
      <td>${this.formatInstallmentDetails(item.student_receipts_details)}</td>
      <td>${this.formatInstallmentDetails(item.student_receipts_details_misc)}</td>
      <td>${this.formatInstallmentDetails(item.student_receipts_details_canteen)}</td>
      <td>${item.all_comp ? item.all_comp[0] : ''}</td> 
      <td>${item.all_comp ? item.all_comp[1] : ''}</td>
      <td>${item.all_comp ? item.all_comp[2] : ''}</td>
    </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
formatInstallmentDetails(details) {
    if (!details || details.length === 0) {
      return 'N/A'; 
    }

    let table = `<table border="1" style="margin: 5px;">
        <tr>
          <th>Sr No</th>
          <th>Receipt Date</th>
          <th>Receipt No</th>
          <th>Amount</th>
          <th>Remark</th>
        </tr>`;
    details.forEach(detail =>{
        table += `<tr>
          <td style="text-align: center">${detail.srno || ''}</td>
          <td style="text-align: center">${detail.receipt_date || ''}</td>
          <td style="text-align: center">${detail.receipt_no || ''}</td>
          <td style="text-align: center">${detail.amount || ''}</td>
          <td style="text-align: center">${detail.remark || ''}</td>
        </tr>`;
    });
    table += '</table>';
    return table;

// Concatenate details into a string
    // return details.map(detail => {
    //   return `  Sr No: ${detail.srno}, Receipt Date: ${detail.receipt_date},Receipt No: ${detail.receipt_no},Amount: ${detail.amount},Remark: ${detail.remark}`;
    // }).join('<br>');
  },
            clear() {
                this.learner_info = [];
                this.data_list = [];
            },
            getAllReport() {
                this.learner_info = []
                this.component_headers = []
                this.loader = true;
                const data = {
                    ay: this.current_academic_year.ay,
                    std: this.std.standard,
                    type: this.type,
                    org: this.org,
                    status: this.status,
                };
                axios
                    .post("/ZealExamination/getAccountDashboard", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                             this.learner_info = res.data.learner_info;
                             this.component_headers = res.data.header_list
                             this.loader = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.overlay = false;
                        }
                    })
                   .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            getStandard() {
                const data = {
                    ay: this.current_academic_year.id,
                    std: this.std,
                };
                axios
                    .post("/InstallmentStructureDetails/getStandard", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.dision_list = res.data.dision_list;
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/InstallmentStructureDetails/getAllData")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.academic_year_list = res.data.ay_data;
                            this.current_academic_year = res.data.cay;
                            this.standard_list = res.data.standard_list
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.get_ay_std_ft_loader = false;
                    });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .scroll {
        overflow-x: scroll;
    }
    .text-color {
        font-weight: bold;
        color: red;
        font-size: small;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .dt-button {
        font-size: small;
        font-weight: bold;
    }
    .dt-button.buttons-print::before {
        content: "\F42A";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    .dt-button.buttons-excel::before {
        content: "\F21B";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    .dt-button.buttons-csv::before {
        content: "\FEC2";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    button.dt-button:hover:not(.disabled),
    div.dt-button:hover:not(.disabled),
    a.dt-button:hover:not(.disabled) {
        border-color: #ff9800;
        color: #ff9800;
    }
    .dataTables_wrapper .dataTables_filter input[type="search"] {
        border-radius: 2px;
        border: 1px solid #cdcdcd;
        cursor: auto;
        white-space: nowrap !important;
    }
   
</style>
